import React from "react";
import { RCCButton, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import DefaultBody from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultBody";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { ActionGroupers, ActionTraceability } from "src/pages/Actions/Panel/interface";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";
import { IDashboardActionsData } from "../interface";
import Li from "./li";
import * as Styles from "./styles";

const DashboardListsActions: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate } = useTranslation();

	const {data , loading} = useEffectFetchData<IDashboardActionsData[]> (
		"DashboardActions/List", 
		{ group: true }
	);


	const dataCard = data && data.length > 0 ? data : [{
		canceled: 0,
		draft: 0,
		dueDateExpired: 0,
		finished: 0,
		group: 8,
		inProgress: 0,
		notStarted: 0,
		title: "",
		total: 0
	} as IDashboardActionsData]; 

	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Resumo Ações por Origem")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<Link to={`/actions/panel/?group=${ActionGroupers.ORIGIN}`} >
					<RCCTooltip
						text={translate("Painel de ações")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="actions"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
				<Link to="/actions/matrix">
					<RCCTooltip
						text={translate("Matriz de ações")}
						color="grey"
					>
						<RCCButton 
							color="transparent"
							icon={{
								name: "table",
								color: "var(--app-icons-color)"
							}}
						/>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>
			<DefaultBody>
				{dataCard && dataCard.length > 0 && (
					<>
						<Styles.LiTitles>
							<div />
							<div><RCCTooltip text={translate("Não iniciadas")} color="purple" >{translate("Não iniciadas")} </RCCTooltip></div>
							<div><RCCTooltip text={translate("Em andamento")} color="blue" >{translate("Em andamento")} </RCCTooltip></div>
							<div><RCCTooltip text={translate("Atrasadas")} color="red" >{translate("Atrasadas")} </RCCTooltip></div>
							<div><RCCTooltip text={translate("Concluídas")} color="green" >{translate("Concluídas")} </RCCTooltip></div>
						</Styles.LiTitles>

						<Styles.LiPanelBodyContent hidden={dataCard.find((x) => x.group === 1) === undefined}>
							<div>
								<Title color="purple" size="sm">
									{translate("Iniciativa")} - {translate("Mapa")}
								</Title>
							</div>
							<Li data={dataCard.find((x) => x.group === 1)} origin={ActionTraceability.INICIATIVE_MAP} />
						</Styles.LiPanelBodyContent>

						<Styles.LiPanelBodyContent hidden={dataCard.find((x) => x.group === 2) === undefined}>
							<div>
								<Title color="purple" size="sm">
									{translate("Iniciativa")} - {translate("OKR")}
								</Title>
							</div>
							<Li data={dataCard.find((x) => x.group === 2)} origin={ActionTraceability.INICIATIVE_OKR} />
						</Styles.LiPanelBodyContent>

						<Styles.LiPanelBodyContent hidden={dataCard.find((x) => x.group === 3) === undefined}>
							<div>
								<Title color="purple" size="sm">
									{translate("FCA")} - {translate("Indicador")}
								</Title>
							</div>
							<Li data={dataCard.find((x) => x.group === 3)} origin={ActionTraceability.FCA_INDICATOR} />
						</Styles.LiPanelBodyContent>

						<Styles.LiPanelBodyContent hidden={dataCard.find((x) => x.group === 4) === undefined}>
							<div>
								<Title color="purple" size="sm">
									{translate("Reunião")} 
								</Title>
							</div>
							<Li data={dataCard.find((x) => x.group === 4)} origin={ActionTraceability.MEETING} />
						</Styles.LiPanelBodyContent>

						<Styles.LiPanelBodyContent hidden={dataCard.find((x) => x.group === 5) === undefined}>
							<div>
								<Title color="purple" size="sm">
									{translate("Projeto")} 
								</Title>
							</div>
							<Li data={dataCard.find((x) => x.group === 5)} origin={ActionTraceability.PROJECT} />
						</Styles.LiPanelBodyContent>

						<Styles.LiPanelBodyContent hidden={dataCard.find((x) => x.group === 6) === undefined}>
							<div>
								<Title color="purple" size="sm">
									{translate("Risco")} 
								</Title>
							</div>
							<Li data={dataCard.find((x) => x.group === 6)} origin={ActionTraceability.RISK} />
						</Styles.LiPanelBodyContent>

						<Styles.LiPanelBodyContent hidden={dataCard.find((x) => x.group === 7) === undefined}>
							<div>
								<Title color="purple" size="sm">
									{translate("Ocorrência")} 
								</Title>
							</div>
							<Li data={dataCard.find((x) => x.group === 7)} origin={ActionTraceability.OCCURRENCE} />
						</Styles.LiPanelBodyContent>

						<Styles.LiPanelBodyContent hidden={dataCard.find((x) => x.group === 8) === undefined}>
							<div>
								<Title color="purple" size="sm">
									{translate("Suas")} {translate("ações")}
								</Title>
							</div>
							<Li data={dataCard.find((x) => x.group === 8)} origin={ActionTraceability.ACTION} myActions />
						</Styles.LiPanelBodyContent>
					</>
				)}	
			</DefaultBody>
		</DefaultContainer>
	);
};

export default DashboardListsActions;
